// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1U37A","name":"Header_name__3jsY6","birthday":"Header_birthday__3cQQm","skeleton":"Header_skeleton__1KBlP"};